import { gql } from 'urql';

export const LIST_CUENTAS = gql`
  query ListCuentas($search: String, $imputable: Boolean, $activo: Boolean, $tipo: CuentaTipo, $padreId: ID, $limit: Int, $offset: Int) {
    listCuentas(pagination: { limit: $limit, offset: $offset }, filter: {
      search: $search
      imputable: $imputable
      activo: $activo
      tipo: $tipo
      padreId: $padreId
    }) {
      total
      items {
        id
        codigo
        nombre
        tipo
        nivel
        padreId
        imputable
        moneda
        activo
        createdAt
        updatedAt
      }
    }
  }
`;

export const ARBOL_CUENTAS = gql`
  query ArbolCuentas($activo: Boolean) {
    arbolCuentas(activo: $activo) {
      id
      codigo
      nombre
      tipo
      nivel
      imputable
      activo
      moneda
      hijos {
        id
        codigo
        nombre
        tipo
        nivel
        imputable
        activo
        moneda
        hijos {
          id
          codigo
          nombre
          tipo
          nivel
          imputable
          activo
          moneda
        }
      }
    }
  }
`;

export const CREAR_CUENTA = gql`
  mutation CrearCuenta($input: CuentaInput!) {
    crearCuenta(input: $input) {
      id
      codigo
      nombre
      tipo
      nivel
      padreId
      imputable
      moneda
      activo
    }
  }
`;

export const ACTUALIZAR_CUENTA = gql`
  mutation ActualizarCuenta($id: ID!, $input: CuentaUpdateInput!) {
    actualizarCuenta(id: $id, input: $input) {
      id
      codigo
      nombre
      tipo
      nivel
      padreId
      imputable
      moneda
      activo
    }
  }
`;

export const ACTIVAR_CUENTA = gql`
  mutation ActivarCuenta($id: ID!, $activo: Boolean!) {
    activarCuenta(id: $id, activo: $activo) {
      id
      codigo
      nombre
      activo
    }
  }
`;

